import React, { PureComponent } from 'react'
import ReactDOM from 'react-dom'
import InlineLoader from 'modules/common/components/inlineloader'
import Map from './Map'

const infoWindow = (onClick) => {
  const info = new window.google.maps.InfoWindow();
  
  return (map, marker, label, id, redirect_fi) => {
    const contentStr = `<div class="infowindow"></div>`
    info.setContent(contentStr)
    info.open(map, marker)
    setTimeout(() =>{
      const mountingNode = document.querySelector('.infowindow')
      const wrapper = mountingNode.appendChild(document.createElement('div'));
      ReactDOM.render(
        <p>
          <b className="infowindow__course-name">{label}</b>
          { redirect_fi && <a className="infowindow__button" href={`https://fi.birdietime.com/courses/${id}`}>Open page</a>}
          { !redirect_fi && <a className="infowindow__button" onClick={event => onClick(event, id)}>Open page</a>}
        </p>,
        wrapper
      );
    }
    ,0)
  }
}

class CourseMap extends PureComponent {

  state = {
    info: undefined,
    activeMarkers: [],
  }

  componentWillMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props
    if (!isScriptLoaded && !isScriptLoadSucceed) {
      return
    }
    this.loadData()
    this.setState({
      info: infoWindow(this.gotoCoursePage)
    })
  }

  componentWillReceiveProps(nextProps){
    const {
      info
    } = this.state
    const {
      isScriptLoaded,
      isScriptLoadSucceed
    } = nextProps
    if(isScriptLoaded && !this.props.isScriptLoaded && isScriptLoadSucceed){
      this.loadData()
      if(!info){
        this.setState({
          info: infoWindow(this.gotoCoursePage)
        })
      }
    }
  }

  loadData = () => {
    const { loadCourses, loadAllCourses } = this.props;
    if(loadAllCourses){
      loadCourses()
    }
  }

  openInfoWindow = (map, marker, label, id, redirect_fi) => {
    const {
      info
    } = this.state
    if(info){
      info(map, marker, label, id, redirect_fi)
    }
  }

  onMarkerMouseOver = (marker) => {
    const {
      onMarkerMouseOver
    } = this.props
    if(onMarkerMouseOver){
      onMarkerMouseOver(marker)
    }

  }
  onMarkerMouseOut = (marker) => {
    const {
      onMarkerMouseOut
    } = this.props
    if(onMarkerMouseOut){
      onMarkerMouseOut(marker)
    }
  }
  
  gotoCoursePage = (event, id, name) => {
    event.preventDefault();
    const { history } = this.props
    history.push(`/courses/${id}`)
  }

  render() {
    const {
      courses = [],
      searchMap,
      gridSize,
      minimumClusterSize,
      activeCourses = [],
      minZoom,
      isScriptLoaded,
      isScriptLoadSucceed,
      google,
      disableFiClubLoading,
    } = this.props

    
    const {
      activeMarkers = []
    } = this.state
    
    if (!courses || (!isScriptLoaded && !isScriptLoadSucceed)) {
      return <InlineLoader />
    }
    
    return (
      <Map
        searchMap={searchMap}
        google={google}
        courses={courses}
        onMarkerClick={this.openInfoWindow}
        onMarkerMouseOver={this.onMarkerMouseOver}
        onMarkerMouseOut={this.onMarkerMouseOut}
        gridSize={gridSize}
        minimumClusterSize={minimumClusterSize}
        activeCourses={activeCourses}
        activeMarkers={activeMarkers}
        minZoom={minZoom}
        center={{lat: 53, lng: 0}}
        zoom={3}
        disableFiClubLoading={disableFiClubLoading}
      />
    )
  }
}

export default CourseMap



// WEBPACK FOOTER //
// ./src/modules/common/components/map/CourseMap.js